<template>
    <b-dropdown variant="primary" :class="className" no-caret :disabled="disabled">
        <template #button-content>
            <slot>
                Export
            </slot>
            <b-icon-box-arrow-in-down-right/>
        </template>
        <b-dropdown-item v-if="hasType('csv')" @click="exportAs('csv')">CSV</b-dropdown-item>
        <b-dropdown-item v-if="hasType('xlsx')" @click="exportAs('xlsx')">Microsoft Excel</b-dropdown-item>
        <b-dropdown-item v-if="hasType('txt')" @click="exportAs('txt')">Text</b-dropdown-item>
        <b-dropdown-item v-if="hasType('html')" @click="exportAs('html')">HTML</b-dropdown-item>
        <b-dropdown-item v-if="hasType('rtf')" @click="exportAs('rtf')">RTF</b-dropdown-item>

        <b-modal id="export-modal" @ok="doExport">
            <b-input-group prepend="Saved Profiles">
                <b-form-select :options="profileOptions" v-model="selectedProfile"></b-form-select>
                <b-input-group-append>
                    <b-button @click="loadProfile">Load</b-button>
                    <b-button @click="deleteProfile" variant="danger">
                        <b-icon-trash/>
                    </b-button>
                </b-input-group-append>
            </b-input-group>

            <hr>
            <b-form-group label="Export Fields">
                <b-form-checkbox-group :options="fieldOptions" v-model="selectedFields"></b-form-checkbox-group>
            </b-form-group>

            <hr>
            <b-input-group prepend="Create Profile ">
                <b-form-input v-model="profileName" placeholder="Enter new profile name here"></b-form-input>
                <b-input-group-append>
                    <b-button @click="saveProfile" :disabled="!profileName || profileName.length < 2">Save</b-button>
                </b-input-group-append>
            </b-input-group>
        </b-modal>
    </b-dropdown>
</template>

<script>
import * as _ from 'lodash'

export default {
    name: 'ExportButton',
    props: {
        className: String,
        profileKey: String,
        types: Array,
        fields: Object,
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            selectedFields: [],
            type: '',

            selectedProfile: null,
            exportProfiles: {},
            profileName: '',
        }
    },
    computed: {
        fieldOptions () {
            let options = []
            _.each(_.keys(this.fields), (key) => {
                options.push({ text: this.fields[key], value: key })
            })
            return options
        },
        profileOptions () {
            return _.keys(this.exportProfiles)
        }
    },
    methods: {
        hasType (type) {
            return !this.types || this.types.includes(type)
        },
        exportAs (type) {
            this.type = type
            this.selectedFields = _.keys(this.fields)

            if (this.fields) {
                this.showModal()
            } else {
                this.doExport()
            }
        },
        doExport () {
            let fieldsObject = {}
            _.each(this.selectedFields, (key) => {
                fieldsObject[key] = this.fields[key]
            })
            this.$emit('export', this.type, fieldsObject)
        },
        showModal () {
            this.loadProfiles()
            this.$bvModal.show('export-modal')
        },
        loadProfiles () {
            this.exportProfiles = JSON.parse(localStorage.getItem('export-profile' + this.profileKey))
            if (this.exportProfiles == null) {
                this.exportProfiles = {}
            }
        },
        loadProfile () {
            if (this.selectedProfile) {
                this.selectedFields = this.exportProfiles[this.selectedProfile]
            }
        },
        saveProfile () {
            this.$set(this.exportProfiles, this.profileName, this.selectedFields)
            localStorage.setItem('export-profile' + this.profileKey, JSON.stringify(this.exportProfiles))
            this.profileName = null
        },
        deleteProfile () {
            this.$delete(this.exportProfiles, this.selectedProfile)
            localStorage.setItem('export-profile' + this.profileKey, JSON.stringify(this.exportProfiles))
            this.selectedProfile = null
        }

    },
}
</script>
